<template>
  <div>
    <div class="d-flex justify-space-between">
      <back-button /> <delete-button v-if="id" @click="del()" />
    </div>
    <v-progress-linear v-if="loading" indeterminate />
    <div v-else>
      <page-header>
        {{ partner.name || "Добавить партнёра" }}
        <v-btn
          v-if="partner.name"
          class="ml-5"
          @click="$router.push(`/partners/${id}/goods`)"
        >
          <v-icon class="mr-2">mdi-widgets</v-icon>Товары партнёра
        </v-btn>
      </page-header>
      <partner-form :partner="partner" @submit="submitForm" />
      <api-key v-if="id" :token="partner.token" :id="partner.id" />
      <statistic v-if="id" :id="partner.id" />
    </div>
  </div>
</template>

<script>
import api from "../api";
import axios from "axios";
import PartnerForm from "../components/PartnerForm";
import BackButton from "../components/BackButton";
import DeleteButton from "../components/DeleteButton";
import PageHeader from "../components/PageHeader";
import ApiKey from "../components/ApiKey";
import Statistic from "../components/Statistic";
import store from "../store";

export default {
  name: "partner",
  components: {
    PartnerForm,
    BackButton,
    DeleteButton,
    PageHeader,
    ApiKey,
    Statistic
  },
  data() {
    return {
      loading: false,
      partner: {}
    };
  },
  computed: {
    id() {
      return Number(this.$route.params.id);
    }
  },
  methods: {
    del() {
      if (confirm("Вы уверены, что хотите удалить?")) {
        this.loading = true;
        axios
          .delete(`${api.partners}/${this.id}`)
          .then(() => {
            store.snackbar = true;
            store.snackbarSuccess = true;
            store.snackbarMessage = "Партнёр удалён";
            this.$router.push({ name: "partners" });
          })
          .catch(err => {
            store.snackbar = true;
            store.snackbarMessage = err.message;
            store.snackbarSuccess = false;
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    getItem() {
      this.loading = true;
      axios
        .get(`${api.partners}/${this.id}`)
        .then(resp => {
          this.partner = resp.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    submitForm(partner) {
      this.loading = true;
      if (this.id) {
        axios
          .put(`${api.partners}/${this.id}`, partner)
          .then(resp => {
            this.partner = resp.data;
            store.snackbar = true;
            store.snackbarSuccess = true;
            store.snackbarMessage = "Партнёр обновлён";
          })
          .catch(err => {
            store.snackbar = true;
            store.snackbarSuccess = false;
            store.snackbarMessage = `${err.response.data[0].field}: ${err.response.data[0].message}`;
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        axios
          .post(api.partners, partner)
          .then(resp => {
            this.partner = resp.data;
            store.snackbar = true;
            store.snackbarSuccess = true;
            store.snackbarMessage = "Партнёр добавлен";
            this.$router.push(`/partners/${this.partner.id}`);
          })
          .catch(err => {
            store.snackbar = true;
            store.snackbarSuccess = false;
            store.snackbarMessage = `${err.response.data[0].field}: ${err.response.data[0].message}`;
          })
          .finally(() => {
            this.loading = false;
          });
      }
    }
  },
  mounted() {
    if (this.id) this.getItem();
  }
};
</script>
